import styled from 'styled-components';

import { maxWidth } from '@calm-web/design-system';

export const LandingPageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	height: 100%;
	background: #e1e4e9;

	section {
		height: 100%;
		top: 0;
	}

	${maxWidth('tablet')} {
		section {
			display: flex;
			flex-direction: column;

			h1 {
				max-width: 335px;
				text-align: center;
			}

			p {
				margin: auto 20px;
				text-align: center;
			}

			> div:first-child {
				margin-top: 24px;
			}
		}
	}
`;

export const SectionWrapper = styled.div`
	margin-top: 60px;
`;
